import Vue from 'vue';
import App from './App.vue';
import router from './router';

import i18n from './i18n'
import store from '@/state/store';

import VueHotKey from 'v-hotkey';

Vue.use(VueHotKey);





import { initFirebaseBackend } from './helpers/firebase/authUtils';
import { configureFakeBackend } from './helpers/fakebackend/fake-backend';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}



import {Application} from "@/global";

import vco from "v-click-outside"
import VueSlideBar from 'vue-slide-bar'
import BootstrapVue from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'

import VueSweetalert2 from 'vue-sweetalert2';
import * as VueGoogleMaps from 'vue2-google-maps'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/plugins/monthSelect/style.css'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue';
import highchartsMore from 'highcharts/highcharts-more'
import Treemap from 'highcharts/modules/treemap'
import xRange from 'highcharts/modules/xrange';
import variablePie from 'highcharts/modules/variable-pie';
import seriesLabel from 'highcharts/modules/series-label';
import Dropdown from 'vue-simple-search-dropdown';
import VueGauge from 'vue-gauge';

import axios from 'axios';
Vue.prototype.$axios = axios;

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ko';
Vue.use(DatePicker);

/*import io from 'socket.io-client';
const socket = io('http://localhost:3000');

Vue.prototype.$socket = socket;*/

// for @Calvin 충전이용현황 xrange 차트 이용에 필요. 지우지 마세요
if (typeof Highcharts === 'object') {
  highchartsMore(Highcharts)
  xRange(Highcharts)
  variablePie(Highcharts)
  Treemap(Highcharts)
  seriesLabel(Highcharts)
}

// how to set highcharts thousandsSep comma options globally !! @Yeony
Highcharts.setOptions({
  lang: { thousandsSep: ',', numericSymbols: null}
})

Vue.use(HighchartsVue, { tagName: 'highcharts' })

import VueGeolocationApi from 'vue-geolocation-api'
Vue.use(VueGeolocationApi)

// CSS
import '@/assets/scss/app.scss';
import '@/assets/scss/app-ev.scss';


import moment from "@/assets/plugins/moment";
window.moment = Vue.prototype.$moment = moment

import VueScrollProgress from 'vue-scroll-progress';
Vue.use(VueScrollProgress);

Vue.component('Dropdown', Dropdown)
Vue.component('VueGauge', VueGauge)

Vue.component('VueSlideBar', VueSlideBar)
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(vco)
// Vue.use(highCharts)
Vue.use(vueCustomScrollbar)
Vue.use(VueFlatPickr)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
});

Vue.config.productionTip = false

Vue.prototype.$_app  = Vue.observable(new Application(router))

// Custom
import common from '@/assets/js/common.js'
Vue.use(common)

import mapData from '@/assets/js/common-map-data'
Vue.use(mapData)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
